import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface AllotmentRangeTypeEditorViewProps  {
    value: number | null;
    mode: ControlMode;
    onChanged: (number: number | null) => void;
    label?: string;
    required?: boolean;
}

export class AllotmentRangeTypeEditorView extends React.Component<AllotmentRangeTypeEditorViewProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        let label = this.props.label;
        if (label === undefined) {
            label = 'Allotment type';
        }
        return (
            <DropdownView
                label={label}
                onChanged={(item) => { this.props.onChanged(item != null ? item.value : null); }}
                required={this.props.required}
                model={this.props.value}
                disabled={this.props.mode == 'display'}
                options={
                    [
                        { value: 0, label: 'Stopsale' },
                        { value: 1, label: 'By availability' },
                        { value: 2, label: 'By request' },
                        { value: 3, label: 'Unavailable' },
                        { value: 4, label: 'Freesell' }
                    ]
                }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/products/allotment-range/parts/allotment-range-type-editor.view.tsx